<div class="flex flex-row">
  <div class="w-1/2 border-r border-[#868A91] p-[10px]">
    <ng-content select="[left]"></ng-content>
  </div>
  <div class="w-1/2 p-[10px]"><ng-content select="[right]"></ng-content></div>
</div>
